export default __webpack_public_path__ + "assets/3f2712e63e70794b0c9af5cd616acf4f.woff2";